import { getQueryString, getSourceWay } from '@/utils'
import { useEffect, useState } from 'react'
import { getOrderPay, queryOrderDetail, orderCancel } from './service'
import { OrderDetailInfo, mockData } from './mode'
import Toast from '@df-mobile/toast'
import { increaseLoading, decreaseLoading } from '@df-mobile/library2'

export const useOrderDetailHooks = () => {
  const [sourceData, setSourceData] = useState<OrderDetailInfo>()
  const bussinessType = Number(getQueryString('type') || 1)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const sn = getQueryString('sn')

  useEffect(() => {
    window.addEventListener('pageshow', (e: any) => {
      if (
        e.persisted ||
        (window.performance && window.performance.navigation.type === 2)
      ) {
        window.location.reload()
      }
    })
    return () => {
      window.removeEventListener('pageshow', function (e) {})
    }
  }, [])
  useEffect(() => {
    loadDetailData()
    // setSourceData(mockData);
  }, [])

  /**加载详情数据 */
  const loadDetailData = () => {
    const param = {
      sn,
    }
    increaseLoading()
    queryOrderDetail(param)
      .then((res: any) => {
        setIsLoading(false)
        decreaseLoading()
        if (res?.Data) {
          console.log('res?.Data', res?.Data)
          setSourceData(JSON.parse(JSON.stringify(res?.Data || {})))
        } else {
          setSourceData({})
          Toast({ content: res?.Message || '' })
        }
      })
      .catch((err) => {
        setIsLoading(false)
        decreaseLoading()
      })
  }

  /**获取支付链接 */
  const queryPayUrl = () => {
    increaseLoading()
    getOrderPay({ sn, sourceWay: getSourceWay() })
      .then((res: any) => {
        decreaseLoading()
        if (res?.Data?.url) {
          window.df_sdk_common.location.href = res?.Data?.url
        } else {
          Toast({ content: res?.Message || '' })
        }
      })
      .catch((_) => {
        decreaseLoading()
      })
  }

  /**取消订单 */
  const handleCancleOrder = () => {
    increaseLoading()
    orderCancel({ sn })
      .then((res: any) => {
        decreaseLoading()
        if (res?.Data) {
          Toast({ content: '取消成功' })
          loadDetailData()

          // window.location.reload();
        } else {
          Toast({ content: res?.Message || '' })
        }
      })
      .catch((_) => {
        decreaseLoading()
      })
  }

  return {
    loadDetailData,
    sourceData,
    isLoading,
    queryPayUrl,
    handleCancleOrder,
  }
}
